import React from "react";
import { Pressable } from "../../../pressable";

import styles from "./styles.modules.scss";

import { Label } from "./label";
import { LinkType } from "./type";
import { useOpenNewsArticle } from "../../../../hooks/use-open-news-article";

export const Link = ({
    disabled,
    label,
    LabelComponent,
    labelComponentProps,
    next,
}: LinkType) => {
    const openNewsArticle = useOpenNewsArticle();

    const onClick = () => {
        if (!labelComponentProps?.data?.disableOnClick) {
            return openNewsArticle(
                labelComponentProps.data.id,
                label ?? labelComponentProps?.data?.title ?? "",
                labelComponentProps.data.type === "esportNewsEntry"
                    ? "esport"
                    : "news",
            );
        }
    };

    return (
        <div
            className={`link ${styles.link} ${
                disabled ? `disabled ${styles.disabled}` : ""
            } ${next ? `next ${styles.next}` : ""} `}
            onClick={onClick}
        >
            <Pressable>
                <div className={`container ${styles.container}`}>
                    <div className={`icon ${styles.icon}`} />

                    <div className={`label ${styles.label}`}>
                        <Label
                            label={label}
                            Component={LabelComponent}
                            componentProps={labelComponentProps}
                        />
                    </div>
                </div>
            </Pressable>
        </div>
    );
};
